import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FdAlertComponent,
  ModalDefinitions,
} from "src/app/shared/fd-form-components/fd-alert/fd-alert.component";
import { FdFieldConfigs } from "src/app/shared/fd-form-components/fd-form-components.module";
import { Messages } from "src/app/shared/messages/messages";
import { ErrorService } from "src/app/shared/service/error.service";
import { LoadingService } from "src/app/shared/service/loading.service";
import { FAQCategorySaveModel } from "../../models/faq-category.model";
import { CategoryService } from "../../services/faq-category.service";

@Component({
    selector: 'app-add-faq-category',
    templateUrl: './add-faq-category.component.html',
    styleUrls: ['./add-faq-category.component.scss'],
    standalone: false
})
export class AddFAQCategoryComponent implements OnInit, OnDestroy {
  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  fieldsArray: FdFieldConfigs[] = new Array<FdFieldConfigs>();
  selectedInstitution: string;
  selectedServiceContract: number;
  selectedCategoryId: number;
  alive = true;

  ngOnDestroy() {
    this.alive = false;
  }

  constructor(
    private categoryService: CategoryService,
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<AddFAQCategoryComponent>,
    private loadingService: LoadingService,
    private errorService: ErrorService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      institution: string;
      serviceContract: number;
    },
    private dialog: MatDialog
  ) {}

  changeSelectedInstitution(institution: string) {
    this.selectedInstitution = institution;
  }
  changeSelectedServiceContract(selectedServiceContract: number) {
    this.selectedServiceContract = selectedServiceContract;
  }

  ngOnInit() {
    this.formGroup = this.createFormGroup();
    this.fields = this.createFields();
  }

  public isFormGroupValid(formGroup?: UntypedFormGroup): boolean {
    const formToBeValidated = !!formGroup ? formGroup : this.formGroup;
    if (formToBeValidated.invalid) {
      this.showErrorMessages(formToBeValidated);
      return false;
    }
    return true;
  }

  private showErrorMessages(formToBeValidated: UntypedFormGroup | UntypedFormArray) {
    let control;
    Object.keys(formToBeValidated.controls)
      .reverse()
      .forEach((field) => {
        control = formToBeValidated.get(field);
        if (control instanceof UntypedFormArray || control instanceof UntypedFormGroup) {
          this.showErrorMessages(control);
        } else {
          if (control && control.invalid) {
            control.markAsTouched();
          }
        }
      });
  }

  protected createFormGroup() {
    return this.formBuilder.group({
      institution: ["", Validators.required],
      serviceContract: ["", Validators.required],
      name: ["", Validators.required],
    });
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    let category: FAQCategorySaveModel = new FAQCategorySaveModel();

    category.institutionId = this.formControls.institution.value;
    category.serviceContractId = this.formControls.serviceContract.value;
    category.name = this.formControls.name.value;

    this.loadingService.show();

    this.categoryService.saveCategory(category).subscribe(
      (response) => {
        this.loadingService.hide();

        const successDialogRef = this.dialog.open(FdAlertComponent, {
          disableClose: true,
          width: ModalDefinitions.DEFAULT_MODAL_WIDTH,
          data: Messages.FAQ_CATEGORY_SAVE_SUCCESS,
        });

        successDialogRef.afterClosed().subscribe((obs) => {
          this.dialogRef.close({ data: response });
        });
      },
      (error) => {
        this.loadingService.hide();
        this.errorService.handleXHRError(error, Messages.GENERAL_ERROR);
      }
    );
  }

  createFields(): FdFieldConfigs {
    return {
      institution: {
        label: "Nº Instituição",
        controlName: "institution",
        maskCharsReplace: /[. / -]/g,
        panelWidth: '320px',
        messages: {
          required: "Informe uma instituição",
          invalid: "Usuário inválido",
        },
      },
      serviceContract: {
        label: "Service Contract",
        controlName: "serviceContract",
        maskCharsReplace: /[. / -]/g,
        panelWidth: '320px',
        messages: {
          required: "Informe um service contract",
          invalid: "Usuário inválido",
        },
      },
      name: {
        label: "Name",
        controlName: "name",
        maxLength: 150,
        messages: {
          required: "Insira um nome"},
      },
    };
  }
}
